import ProNotification from './notification';

export default ProNotification;
